import { useTranslation } from 'next-i18next'
import { Ficello } from '@captaincause/ui/Ficello'
import { Button } from 'components/Button'
import { Footer } from 'components/Footer'
import { Nav } from './Nav'
import type { Localization } from '@captaincause/types'

function Error500() {
  const { t } = useTranslation('errors.page')

  return (
    <>
      <h1 className="text-xl font-semibold md:text-2xl">{t('500.title')}</h1>
      <h2 className="mt-2 text-lg">{t('500.subtitle')}</h2>

      <p className="mt-8">{t('500.paragraph')}</p>
      <div className="mt-6 flex space-x-4 md:space-x-6">
        <Button href="/">{t('500.back')}</Button>

        <Button onClick={() => window.location.reload()}>
          {t('500.reload')}
        </Button>
      </div>
    </>
  )
}

function Error404() {
  const { t } = useTranslation('errors.page')

  return (
    <>
      <h1 className="text-xl font-semibold md:text-2xl">{t('404.title')}</h1>
      <h2 className="mt-2 text-lg">{t('404.subtitle')}</h2>

      <Button variant="primary" className="mt-6" href="/">
        {t('404.back')}
      </Button>
    </>
  )
}

const ERRORS: Record<number, typeof Error404 | typeof Error500> = {
  404: Error404,
  500: Error500,
}

interface ErrorPageProps {
  statusCode: 404 | 500 | undefined
}

const LOCALIZATIONS: Localization[] = [{ locale: 'fr' }, { locale: 'en' }]

export function Error({ statusCode }: ErrorPageProps) {
  const { t } = useTranslation('errors.page')

  const status = statusCode || 500
  const Component = ERRORS[status]

  return (
    <>
      {statusCode === 404 ? <Nav localizations={LOCALIZATIONS} /> : null}

      <main className="relative h-full w-full overflow-hidden">
        <div className="relative z-[1] mx-auto max-w-4xl px-4 py-16 text-center md:py-32">
          <div className="min-w-1/2 mx-auto flex w-[80%] flex-col items-center rounded-md border border-inside bg-white p-6">
            <Component />
          </div>
          <div className="mx-auto mt-6 max-w-xl">
            <p className="text-sm italic">{t(`${status}.georges`)}</p>
            <span className="mt-4 flex items-center justify-center text-sm">
              ― Georges B.
            </span>
          </div>
        </div>
        <Ficello
          variant="virage"
          className="absolute left-[500px] top-[500px] w-[1232px]"
          stroke="green"
        />
        <Ficello
          variant="hp"
          className="absolute left-[-700px] top-[-300px] w-[1232px] rotate-[60deg]"
          stroke="purple"
        />
      </main>

      {statusCode === 404 ? <Footer hideFooterCta /> : null}
    </>
  )
}
